import styled from "@emotion/styled";
import Calendar from "./calendar";
import { CustomAlert } from "./customAlert";
import { WarningIcon } from "../assets/icons/icons";
import { useState } from "react";
import theme from "../theme";
import { useI18n } from "../locales";

interface CalendarsProps {
  startDate?: Date | null;
  endDate?: Date | null;
  setStartDate: any;
  setEndDate: any;
  isSeparate: boolean;
  width?: number;
  justifyContent?: string;
  gap?: string;
  isClearable?: boolean; // 날짜 지우기 버튼
}

const Calendars: React.FC<CalendarsProps> = (props) => {
  const { t } = useI18n();
  const {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    isSeparate,
    width,
    justifyContent,
    gap,
    isClearable,
  } = props;
  let today = new Date();
  const [openAlert, setOpenAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");

  const changeStartDate = (date: Date | null) => {
    setStartDate(date);
    if (date !== null && endDate !== null && endDate !== undefined) {
      if (date > today) {
        setAlertContent("시작일은 현재보다 미래일 수 없습니다.");
        setOpenAlert(true);
        setStartDate(today);
        return;
      }
      if (date > endDate) {
        setAlertContent("시작일은 종료일보다 클 수 없습니다.");
        setOpenAlert(true);
        setEndDate(date);
        return;
      }
    }
  };

  const changeEndDate = (date: Date | null) => {
    setEndDate(date);
    if (date !== null && startDate !== null && startDate !== undefined) {
      if (date > today) {
        setAlertContent("종료일은 현재보다 미래일 수 없습니다.");
        setOpenAlert(true);
        setEndDate(today);
        return;
      }
      if (date < startDate) {
        setAlertContent("종료일은 시작일보다 작을 수 없습니다.");
        setOpenAlert(true);
        setStartDate(date);
        return;
      }
    }
  };

  return (
    <CalendarWrapper
      style={{
        justifyContent: justifyContent ? justifyContent : "normal",
        gap: gap ? gap : `15px`,
      }}
    >
      <Calendar
        width={width}
        header={t.history.from}
        date={startDate}
        setDate={changeStartDate}
        isClearable={isClearable}
      />
      <Separator
        style={isSeparate ? { display: "block" } : { display: "none" }}
      >
        ~
      </Separator>
      <Calendar
        header={t.history.to}
        date={endDate}
        setDate={changeEndDate}
        width={width}
        isClearable={isClearable}
      />
      <CustomAlert
        open={openAlert}
        onPressOK={() => setOpenAlert(false)}
        title="날짜를 확인해 주세요."
        content={alertContent}
        confirmText="확인"
        icon={<WarningIcon />}
      />
    </CalendarWrapper>
  );
};

const CalendarWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Separator = styled.span`
  position: relative;
  top: 10px;
  color: ${theme.color.neutral_500};
`;

export default Calendars;
